import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const RelatedJobs_Box_1 = styled.div`
  padding-top: 12px;
  margin-inline: 20px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-top: 24px;
  }
`;
